import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

const POLL_MS = 60000;

export const useMensajesUnreadStore = defineStore('mensajesUnread', () => {
  const count = ref(0);
  let intervalId: ReturnType<typeof setInterval> | null = null;

  const fetchCount = async () => {
    if (!localStorage.getItem('token')) {
      count.value = 0;
      return;
    }
    try {
      const { data } = await axios.get('mensajes/unread-count');
      count.value = Math.min(999, Number(data?.count || 0));
    } catch {
      count.value = 0;
    }
  };

  const stopPolling = () => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  const startPolling = () => {
    if (!localStorage.getItem('token')) {
      count.value = 0;
      return;
    }
    if (intervalId !== null) {
      return;
    }
    void fetchCount();
    intervalId = setInterval(() => {
      void fetchCount();
    }, POLL_MS);
  };

  /** Tras logout o 401: deja de consultar y pone el contador a 0. */
  const resetAndStop = () => {
    stopPolling();
    count.value = 0;
  };

  return {
    count,
    fetchCount,
    startPolling,
    stopPolling,
    resetAndStop,
  };
});
